__turbopack_context__.v({
  "h1": "Text-module___wEZJq__h1",
  "h2": "Text-module___wEZJq__h2",
  "h3": "Text-module___wEZJq__h3",
  "h4": "Text-module___wEZJq__h4",
  "h5": "Text-module___wEZJq__h5",
  "reading": "Text-module___wEZJq__reading",
  "reading_bold": "Text-module___wEZJq__reading_bold",
  "reading_list": "Text-module___wEZJq__reading_list",
  "reading_medium": "Text-module___wEZJq__reading_medium",
  "reading_medium_bold": "Text-module___wEZJq__reading_medium_bold",
  "reading_small": "Text-module___wEZJq__reading_small",
  "reading_small_bold": "Text-module___wEZJq__reading_small_bold",
  "subheadline_bold": "Text-module___wEZJq__subheadline_bold",
});
